export interface NotificationPreferences {
  userId: number;
  capsuleNotificationStrategy: number; // 0-7
  paymentNotificationStrategy: number; // 0-8
  receiveEmailNotifications: boolean;
  receivePushNotifications: boolean;
  preferredNotificationTime?: string; // "HH:MM"
  capsuleStrategyDescription?: string;
  paymentStrategyDescription?: string;
  message?: string;
}

// Strategy descriptions para Cápsulas
export const CAPSULE_STRATEGY_OPTIONS = [
  { value: 0, label: "Notificações desabilitadas" },
  { value: 1, label: "Apenas situações críticas" },
  { value: 2, label: "Cápsulas próximas ao vencimento (3 dias)" },
  { value: 3, label: "Cápsulas próximas ao vencimento (7 dias)" },
  { value: 4, label: "Semanalmente (resumo)" },
  { value: 5, label: "Quinzenalmente (resumo)" },
  { value: 6, label: "Mensalmente (resumo)" },
  { value: 7, label: "Diariamente nos últimos 10 dias" },
];

// Strategy descriptions para Pagamentos
export const PAYMENT_STRATEGY_OPTIONS = [
  { value: 0, label: "Notificações desabilitadas" },
  { value: 1, label: "Apenas situações críticas" },
  { value: 2, label: "Pagamentos próximos ao vencimento (3 dias)" },
  { value: 3, label: "Pagamentos próximos ao vencimento (7 dias)" },
  { value: 4, label: "Pagamentos em atraso" },
  { value: 5, label: "Semanalmente (resumo)" },
  { value: 6, label: "Quinzenalmente (resumo)" },
  { value: 7, label: "Mensalmente (resumo)" },
  { value: 8, label: "Diariamente nos últimos 10 dias" },
];
